  import { TableDetailsItem } from "../../../components/GridTable/GridTableFunctions";

export const TableDetails: { [key: string]: TableDetailsItem } = {
  "Transaction ID": {
    id: "transaction_id",
    className: "min-w-[160px]",
  },
  "Transaction Date and Time": {
    id: "transaction_date",
    custom: ["transaction_date"],
    className: "min-w-[240px]",
    sort: true,
  },
  "Transaction Done By": {
    id: "transaction_by",
    className: "min-w-[220px]",
  },
  "Phone Number": {
    id: "phone_number",
    className: "min-w-[220px]",
  },
  Telecom: {
    id: "telecom",
    className: "min-w-[220px]",
  },
  Amount: {
    id: "amount",
    custom: ["amount"],
  },
  Location: {
    id: "location",
  },
  "Source Channel": {
    id: "source_channel",
    className: "min-w-[220px]",
  },
  "Transaction Status": {
    id: "status",
    custom: ["custom_status"],
    className: "min-w-[150px]",
  },
};

export const UnsuccessfullTableDetails: { [key: string]: TableDetailsItem } = {
  "Transaction ID": {
    id: "transaction_id",
  },
  "Transaction Date and Time": {
    id: "transaction_date",
    custom: ["transaction_date"],
    className: "min-w-[240px]",
    sort: true
  },
  "Transaction Type": {
    id: "transaction_type",
    className: "min-w-[220px]",
  },
  "Transaction Initiated By": {
    id: "transaction_by",
    className: "min-w-[220px]",
  },
  "Recharged Phone Number": {
    id: "phone_number",
    className: "min-w-[220px]",
  },
  Amount: {
    id: "amount",
    custom: ["amount"],
  },
  "Location": {
    id: "location",
  },
  "Source Channel": {
    id: "source_channel",
    className: "min-w-[220px]",
  },
  "Transaction Status": {
    id: "status",
    custom: ["custom_status"],
    className: "min-w-[150px]",
  },
  Actions: {
    id: "actions",
    customHeader: "Logs",
    className: "min-w-[200px]",
    actionTypes: ["view"],
  },
};

export const purchaseOrderTableDetails: { [key: string]: TableDetailsItem } = {
  "Transaction ID": {
    id: "transaction_id",
    noStretch: true,
  },
  "Transaction Date and Time": {
    id: "transaction_date",
    custom: ["transaction_date"],
    className: "min-w-[240px]",
    sort: true,
    noStretch: true,
  },
  Sender: {
    id: "sender",
    className: "min-w-[220px]",
    noStretch: true,

  },
  Receiver: {
    id: "receiver",
    className: "min-w-[220px]",
    noStretch: true,

  },
  "Sender Mode": {
    id: "sender_mode",
    className: "min-w-[220px]",
    noStretch: true,
  },
  "Receiver Mode": {
    id: "receiver_mode",
    className: "min-w-[220px]",
    noStretch: true,
  },
  "Payment Receipt": {
    id: "payment_receipt",
    className: "min-w-[220px]",
    noStretch: true,
  },
  "Sender Location": {
    id: "sender_location",
    className: "min-w-[220px]",
    noStretch: true,
  },
  "Receiver Location": {
    id: "receiver_location",
    className: "min-w-[220px]",
    noStretch: true,
  },
  Amount: {
    id: "amount",
    custom: ["amount"],
    noStretch: true,
  },
  "Payment Type": {
    id: "payment_type",
    custom: ["payment_type"],
    className: "min-w-[220px]",
    noStretch: true,
  },
  "Upfront Service Fee": {
    id: "commission_amount",
    custom: ["commission_amount"],
    className: "min-w-[220px]",
    noStretch: true,
  },
  "Transaction Status": {
    id: "status",
    custom: ["custom_status"],
    className: "min-w-[160px]",
    noStretch: true,
  },
  "Source Channel": {
    id: "source_channel",
    custom: ["source_channel"],
    className: "min-w-[180px]",
    noStretch: true,
  },
  Actions: {
    id: "actions",
    customHeader: "Logs",
    className: "min-w-[200px]",
    actionTypes: ["view"],
  },
};

export const stockAccountStatementTableDetails: { [key: string]: TableDetailsItem } = {
  "Transaction ID": {
    id: "transaction_id",
  },
  "Transaction Date and Time": {
    id: "created_at",
    custom: ["created_at"],
    className: "min-w-[240px]",
  },
  "Transaction Type": {
    id: "transaction_category",
    className: "min-w-[140px]",
  },
  Sender: {
    id: "sender",
    className: "min-w-[220px]",
  },
  Receiver: {
    id: "receiver",
    className: "min-w-[220px]",
  },
  "Type of Service Fee": {
    id: "commission_type",
  },
  "Service Fee (%)": {
    id: "commission_percentage",
    className: "min-w-[220px]",
  },
  Telecom: {
    id: "telecom",
    className: "min-w-[220px]",
  },
  "Phone Number": {
    id: "phone_number",
    className: "min-w-[220px]",
  },
  "Principal Amount": {
    id: "principal_amount",
    custom: ["principal_amount"],
    className: "min-w-[220px]",
  },
  "Service Fee Amount": {
    id: "commission_amount",
    custom: ["commission_amount"],
    className: "min-w-[220px]",
  },
  Debit: {
    id: "dr_amount",
    custom: ["dr_amount"],
    className: "min-w-[220px]",
  },
  Credit: {
    id: "cr_amount",
    custom: ["cr_amount"],
    className: "min-w-[220px]",
  },
  Actions: {
    id: "actions",
    customHeader: "Balance",
    className: "min-w-[400px]",
    actionTypes: ["balance"],
  },
};

/** Statement Balance column shown only when stage is not production (for stock account statement API). */
const statementBalanceColumn: [string, TableDetailsItem] = [
  "Statement Balance",
  { id: "statement_balance", custom: ["statement_balance"], className: "min-w-[200px]" },
];

function getStockAccountStatementTableDetails(): { [key: string]: TableDetailsItem } {
  const isProd = import.meta.env.VITE_STAGE === "prod";
  if (isProd) return stockAccountStatementTableDetails;
  return { ...stockAccountStatementTableDetails, "Statement Balance": statementBalanceColumn[1] };
}

export const moneyAccountStatementTableDetails: { [key: string]: TableDetailsItem } = {
  "Transaction ID": {
    id: "transaction_id",
    className: "min-w-[160px]",
  },
  "Transaction Date and Time": {
    id: "transaction_date",
    custom: ["transaction_date"],
    className: "min-w-[240px]",
  },
  "Transaction Type": {
    id: "transaction_category",
    className: "min-w-[140px]",
  },
  Split: {
    id: "split",
    className: "min-w-[200px]",
  },
  Debit: {
    id: "amount",
    custom: ["debit"],
    className: "min-w-[150px]",
  },
  Credit: {
    id: "amount",
    custom: ["credit"],
    className: "min-w-[150px]",
  },
  Actions: {
    id: "actions",
    customHeader: "Balance",
    className: "min-w-[180px]",
    actionTypes: ["balance"],
  },
};

export const mnoWiseEtopupTableDetails: { [key: string]: TableDetailsItem } = {
  "Transaction ID": {
    id: "transaction_id",
  },
  "Processed Date and Time": {
    id: "processed_date_time",
    sort: true,
    sortKey: "processed_date",
    custom: ["processed_date_time"],
    className: "min-w-[240px]",
  },
  "Purchased Date": {
    id: "purchased_date",
    sort: true,
    sortKey: "purchased_date",
    custom: ["purchased_date"],
  },
  Description: {
    id: "description",
    className: "min-w-[350px]",
  },
  "MNO Name": {
    id: "mno_name",
    className: "min-w-[220px]",
  },
  "Purchased Amount": {
    id: "purchased_amount",
    custom: ["purchased_amount"],
  },
  "Payment Type": {
    id: "payment_type",
    className: "min-w-[140px]",
  },
  "Payment Mode": {
    id: "payment_mode",
    className: "min-w-[140px]",
  },
  "Bank/Regional Office Name": {
    id: "bank_regional_office_name",
    className: "min-w-[220px]",
  },
  "Transaction Reciept": {
    id: "receipt_url",
    custom: ["receipt_url"],
    className: "min-w-[220px]",
  },
};

export const upfrontSalesTableDetails: { [key: string]: TableDetailsItem } = {
  "Transaction Date and Time": {
    id: "transaction_date",
    custom: ["transaction_date"],
    className: "min-w-[220px]",
  },
  "User Code and Name": {
    id: "user_code",
    custom: ["receiver"],
    className: "min-w-[200px]",
  },
  "Stock Sales Value": {
    id: "amount",
    custom: ["amount"],
    className: "min-w-[220px]",
  },
  "Upfront Commission Paid (%)": {
    id: "commission_percentage",
    custom: ["commission_percentage"],
    className: "min-w-[260px]",
  },
  "Upfront Commission Payout Value": {
    id: "commission_amount",
    custom: ["commission_amount"],
    className: "min-w-[260px]",
  },
  "Source Channel": {
    id: "source_channel",
    custom: ["source_channel"],
    className: "min-w-[180px]",
  },
};

export const upfrontPurchaseTableDetails: { [key: string]: TableDetailsItem } = {
  "Purchase Date": {
    id: "date",
    custom: ["date"],
    className: "min-w-[140px]",
  },
  "MNO Name": {
    id: "mno_name",
    className: "min-w-[220px]",
  },
  "Stock Purchase Value": {
    id: "stock_purchase_value",
    custom: ["stock_purchase_value"],
    className: "min-w-[220px]",
  },
  "Upfront Commission Received (%)": {
    id: "upfront_commission_received_percentage",
    custom: ["upfront_commission_received_percentage"],
    className: "min-w-[260px]",
  },
  "Upfront Commission Received Value": {
    id: "upfront_commission_received_value",
    custom: ["upfront_commission_received_value"],
    className: "min-w-[278px]",
  },
};

export const mnoAvailableBalanceTableDetails: { [key: string]: TableDetailsItem } = {
  "MNO Name": {
    id: "mno_name",
    sort: true,
    className: "min-w-[220px]",
  },
  "eTop Up Balance": {
    id: "etopup_balance",
    custom: ["etopup_balance"],
    className: "min-w-[220px]",
    link: true,
  },
  "Bundle Balance": {
    id: "bundle_balance",
    custom: ["bundle_balance"],
    className: "min-w-[220px]",
    link: true,
  },
  "Total Available Balance": {
    id: "total_available_balance",
    custom: ["total_available_balance"],
    className: "min-w-[220px]",
  },
  "Total Service Fee Earned Balance": {
    id: "total_service_fee_earned_balance",
    custom: ["total_service_fee_earned_balance"],
    className: "min-w-[255px]",
  },
};

export const mnoServiceFeeEarnedTableDetails: { [key: string]: TableDetailsItem } = {
  "Transaction ID": {
    id: "transaction_id",
  },
  "Transaction Date and Time": {
    id: "created_at",
    sort: true,
    custom: ["created_at"],
    className: "min-w-[240px]",
  },
  Description: {
    id: "description",
    className: "min-w-[400px]",
  },
  "Service Fee Type": {
    id: "service_fee_type",
    className: "min-w-[220px]",
  },
  "Service Fee (Debit)": {
    id: "debit",
    custom: ["debit"],
  },
  "Service Fee (Credit)": {
    id: "credit",
    custom: ["credit"],
  },
  "MNO Name": {
    id: "mno_name",
  },
  "Available Balance": {
    id: "available_balance",
    custom: ["available_balance"],
    className: "min-w-[220px]",
  },
};

export const geographicalSalesTableDetails: { [key: string]: TableDetailsItem } = {
  "Date": {
    id: "date",
    custom: ["date"],
    className: "min-w-[140px]",
  },
  "Transactions": {
    id: "transactions",
    custom: ["transactions"],
  },
  "MNO Name": {
    id: "mno_name",
    sort: true,
    custom: ["mno_name"],
    className: "min-w-[240px]",
  },
  "Source Channel": {
    id: "source_channel",
    className: "min-w-[220px]",
  },
  "Country": {
    id: "country",
  },
  "Province": {
    id: "province",
  },
  "Region": {
    id: "region",
  },
  "District": {
    id: "district",
  },
  "Recharge Sales Value": {
    id: "recharge_sales_value",
    custom: ["recharge_sales_value"],
    className: "min-w-[220px]",
  },
};

export const merchantCustomerBalanceTableDetails: { [key: string]: TableDetailsItem } = {
  "User Code": {
    id: "user_code",
    className: "min-w-[120px]",
  },
  "User Name": {
    id: "username",
    sort: true,
    sortKey: "name",
  },
  "User Role": {
    id: "role",
    className: "min-w-[160px]",
  },
  "Phone Number": {
    id: "phone_number",
    className: "min-w-[200px]",
  },
  "Parent Code and Name": {
    id: "parent_code",
    className: "min-w-[250px]",
  },
  "eTop Up Stock": {
    id: "amount",
    className: "min-w-[140px]",
    custom: ["amount"],
  },
  "Location": {
    id: "location",
    className: "min-w-[300px]",
  },
  "User Activity": {
    id: "user_activity",
    className: "min-w-[120px]",
  },
  "Last Transaction Date and Time": {
    id: "last_transaction_date",
    className: "min-w-[250px]",
    custom: ["last_transaction_date"],
  },
};

export const onTargetAchievementOfMNOTableDetails: { [key: string]: TableDetailsItem } = {
  "Transaction ID": {
    id: "transaction_id",
  },
  "Service Fee Received Date": {
    id: "service_fee_received_date",
    custom: ["service_fee_received_date"],
    className: "min-w-[220px]",
  },
  "Service Fee Updated Date and Time": {
    id: "service_fee_updated_date_time",
    custom: ["service_fee_updated_date_time"],
    className: "min-w-[280px]",
  },
  Reference: {
    id: "reference",
    className: "min-w-[400px]",
  },
  Description: {
    id: "description",
    className: "min-w-[400px]",
    custom: ["description"]
  },
  "MNO Name": {
    id: "mno_name",
    className: "min-w-[220px]",
  },
  "Service Fee Received": {
    id: "service_fee_received_amount",
    custom: ["service_fee_received_amount"],
    className: "min-w-[180px]",
  },
  "Running Balance": {
    id: "running_balance",
    custom: ["running_balance"],
    className: "min-w-[200px]",
  },
};
export const reversalTableDetails: { [key: string]: TableDetailsItem } = {
  "Transaction ID": {
    id: "transaction_id",
    className: "min-w-[160px]",
  },
  "Reversal Date and Time": {
    id: "created_at",
    custom: ["created_at"],
    className: "min-w-[240px]",
  },
  "Reference": {
    id: "reference",
    className: "min-w-[400px]",
  },
  "Description": {
    id: "description",
    className: "min-w-[400px]",
  },
  "MNO Name": {
    id: "mno_name",
    className: "min-w-[220px]",
  },
  "Receipt": {
    id: "receipt",
    custom: ["receipt"],
    className: "min-w-[220px]",
  },
  "Credit": {
    id: "credit",
    custom: ["credit"],
    className: "min-w-[220px]",
  },
  "Debit": {
    id: "debit",
    custom: ["debit"],
    className: "min-w-[220px]",
  },
  "Running Balance": {
    id: "running_balance",
    custom: ["running_balance"],
    className: "min-w-[220px]",
    fixed: true,
  },
};

export const etopupDigitalWalletReversalTableDetails: { [key: string]: TableDetailsItem } = {
  "Transaction ID": {
    id: "transaction_id",
    className: "min-w-[160px]",
  },
  "Reversal Date and Time": {
    id: "created_at",
    custom: ["created_at"],
    className: "min-w-[240px]",
  },
  "Reference": {
    id: "reference",
    className: "min-w-[320px]",
  },
  "Description": {
    id: "description",
    className: "min-w-[400px]",
  },
  "Sender": {
    id: "sender",
    className: "min-w-[220px]",
  },
  "Receiver": {
    id: "receiver",
    className: "min-w-[220px]",
  },
  "Wallet": {
    id: "wallet",
    custom: ["wallet"],
  },
  "Receipt": {
    id: "receipt",
    custom: ["receipt"],
    className: "min-w-[220px]",
  },
  "Debit": {
    id: "debit",
    custom: ["debit"],
    className: "min-w-[200px]",
  },
  "Credit": {
    id: "credit",
    custom: ["credit"],
    className: "min-w-[200px]",
  },
  "Running Balance": {
    id: "running_balance",
    custom: ["running_balance"],
    className: "min-w-[200px]",
    fixed: true,
  },
};

export const profitabilityReportTableDetails: { [key: string]: TableDetailsItem } = {
  "Transaction ID": {
    id: "transaction_id",
    className: "min-w-[160px]",
  },
  "Date": {
    id: "date",
    custom: ["date"],
    className: "min-w-[140px]"
    },
  "Transaction Type": {
    id: "transaction_type",
    custom: ["transaction_type"],
    className: "min-w-[150px]",
  },
  "Recharge By": {
    id: "recharge_by",
    className: "min-w-[220px]",
  },
  "Parent": {
    id: "parent",
    className: "min-w-[220px]",
  },
  "Channel Segment": {
    id: "channel_segment",
    className: "min-w-[160px]",
  },
  "Location": {
    id: "location",
    custom: ["profitability_location"],
    className: "min-w-[300px]",
  },
  "MNO Name": {
    id: "mno_name",
    className: "min-w-[200px]",
    sort: true,
  },
  "Recharged Number": {
    id: "recharged_number",
    className: "min-w-[200px]",
  },
  "Recharged Amount": {
    id: "recharge_amount",
    custom: ["recharge_amount"],
    className: "min-w-[180px]",
  },
  "Service Fee Percentage": {
    id: "service_fee_percentage",
    custom: ["service_fee_percentage"],
    className: "min-w-[200px]",
  },
  "Service Fee Type": {
    id: "service_fee_type",
    className: "min-w-[150px]",
  },
  "Debit": {
    id: "debit",
    custom: ["profitability_debit"],
    className: "min-w-[200px]",
  },
  "Credit": {
    id: "credit",
    custom: ["profitability_credit"],
    className: "min-w-[200px]",
  },
  "Balance": {
    id: "balance",
    custom: ["balance"],
    className: "min-w-[200px]",
  },
};

export const cvmReportTableDetails: { [key: string]: TableDetailsItem } = {
  "Transaction ID": {
    id: "transaction_id",
    className: "min-w-[160px]",
  },
  "Transaction Date and Time": {
    id: "transaction_date",
    custom: ["transaction_date"],
    className: "min-w-[240px]",
  },
  "Sender": {
    id: "sender",
    className: "min-w-[120px]",
  },
  "Receiver": {
    id: "receiver",
    className: "min-w-[220px]",
  },
  "Location": {
    id: "location",
    className: "min-w-[200px]",
  },
  "Target Amount": {
    id: "target_amount",
    custom: ["target_amount"],
    className: "min-w-[150px]",
  },
  "Target Achieved": {
    id: "target_achieved",
    custom: ["target_achieved"],
    className: "min-w-[150px]",
  },
  "On Target Achievement Amount Received": {
    id: "on_target_achievement_amount_received",
    custom: ["on_target_achievement_amount_received"],
    className: "min-w-[330px]",
  },
};

export const etopUpSalesTrendTableDetails: { [key: string]: TableDetailsItem } = {
  "Date": {
    id: "date",
    // className: "min-w-[150px]",
    custom: ["date"],
  },
  "MNO Name": {
    id: "mno_name",
    // className: "min-w-[180px]",
  },
  "No of Transactions": {
    id: "no_of_transactions",
    // className: "min-w-[180px]",
  },
  "Recharge Sales": {
    id: "recharge_sales",
    // className: "min-w-[180px]",
    custom: ["recharge_sales"],
  },
  "Channel": {
    id: "channel",
    className: "min-w-[50px]",
  },
};

/**
 * Returns the appropriate table details configuration based on the report type.
 * @param {string} type - The type of the report (e.g., "Unsuccessful Transaction Report").
 * @returns { { [key: string]: TableDetailsItem } } - The corresponding table details object.
 */
export const getTableDetailsByType = (type: string, activeTab: string): { [key: string]: TableDetailsItem } => {
  switch (type) {
    case "Unsuccessful Transaction Report":
      return UnsuccessfullTableDetails;

    case "eTop Up Recharge Report":
      return TableDetails;

    case "Stock Transfer Report":
      return purchaseOrderTableDetails;

    case "Account Statement Report":
      if (activeTab === 'money') {
        return moneyAccountStatementTableDetails;
      } else if (activeTab === 'stock-v2') {
        // Updated stock statement tab: same columns as the stock tab, minus "Statement Balance".
        return stockAccountStatementTableDetails;
      } else {
        return getStockAccountStatementTableDetails();
      }

    case "MNO Wise eTop Up Purchase Report":
      return mnoWiseEtopupTableDetails;

    case "MNO Wise eTop Up Available Balance Report":
      return mnoAvailableBalanceTableDetails;

    case "Upfront Sales Report":
      return upfrontSalesTableDetails;

    case "Upfront Purchase Report":
      return upfrontPurchaseTableDetails;

    case "MNO's Service Fee Earned Report":
      return mnoServiceFeeEarnedTableDetails;

    case "Merchant / Customer eTop Up Wallet Balance Report":
      return merchantCustomerBalanceTableDetails;

    case "Geographical Sales Report":
      return geographicalSalesTableDetails;
    // You can add more cases here for other report types
    // case "Some Other Report":
    //     return SomeOtherTableDetails;
    case "On Target Achievement of MNO Report":
      return onTargetAchievementOfMNOTableDetails;
    
    case "Reversal Report": 
      // Return different table details based on active tab
      // For eTop Up Stock/Digital Wallet Reversal, use etopupDigitalWalletReversalTableDetails
      // For Recharge Reversal (default), use reversalTableDetails
      if (activeTab === 'etopup-stock-digital-wallet-reversal') {
        return etopupDigitalWalletReversalTableDetails;
      }
      return reversalTableDetails;

    case "ZoodPay Profitability Report":
      return profitabilityReportTableDetails;

    case "CVM Report":
      return cvmReportTableDetails;

    case "MNO Wise Sales Trend Report":
      return etopUpSalesTrendTableDetails;
    default:
      // Return a default configuration or an empty object if no type matches
      console.warn(`No table details found for type: ${type}. Returning default.`);
      return TableDetails;
  }
};